import { isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta08ForaAlcanceEnum,
  ConsultaSeguimentoPergunta08Model,
} from './model-consultaSeguimentoPergunta08'

const pergunta08ForaAlcanceEnum = Object.values(ConsultaSeguimentoPergunta08ForaAlcanceEnum)

export const isPergunta08ForaAlcanceAllNao = (
  value: ConsultaSeguimentoPergunta08Model['PERGUNTA_08_FORA_ALCANCE']
): boolean => {
  return isAllNao(value, pergunta08ForaAlcanceEnum)
}
